import React, { Suspense, Fragment, useState, useContext, useCallback, useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import Header from '../../components/header/index';
import Sidenav from '../../components/sidenav/index';
import WebSideNav from "../../components/sidenav/webSideNav";
import Loading from "../../components/loading";
import { Auth } from "../../offline-auth/auth";
import {RoleCtx, SignalerCtx} from "../../lib/context";
import IncommingCall from "../../containers/common/callingModals/incomingCallModal";
import { logout } from '../../actions/users';

const AuthLayout = (props) => {
    const [sideNav, setSideNav] = useState(false);
    const history = useHistory();
    const {setRole} = useContext(RoleCtx);
    const {signaler} = useContext(SignalerCtx);
    const [callerData, setCallerData] = useState(null);

    const handleSideNav = () => {
        setSideNav(prevState => !prevState);
    }
    
    const handleLogout = async (e) => {
        e.preventDefault();
        // setLoading(true);
        // console.log("enter in to logout");
        let logout_res = await logout();
        await Auth.signOut();
        setRole(null)
        history.push("/");
        window.location.reload();
    }

    useEffect(() => {
      if (signaler !== null) {
          const handleReceiveCall = (message) => {
              console.log('before setstate');
              setCallerData(message);
          };
  
          const handleCancelCall = () => {
              setCallerData(null);
          };
  
          const handleDeclineRequestAck = () => {
              setCallerData(null);
          };
  
          const handleAcceptCallAck = () => {
              setCallerData(null);
          };
  
          // Attach event listeners
          signaler.on('recive-call', handleReceiveCall);
          signaler.on('cancel-call', handleCancelCall);
          signaler.on('decline-request-ack', handleDeclineRequestAck);
          signaler.on('accept-call-ack', handleAcceptCallAck);
  
          // Cleanup function
          return () => {
              signaler.off('recive-call', handleReceiveCall);
              signaler.off('cancel-call', handleCancelCall);
              signaler.off('decline-request-ack', handleDeclineRequestAck);
              signaler.off('accept-call-ack', handleAcceptCallAck);
          };
      }
  }, [signaler]);
  

    const declineRequest = () => {
        if (signaler) {
          signaler.declineCallRequest(callerData.senderId, callerData.apptId);
          // signaler.declineCallRequest(doctor.userId, id);
          setCallerData(null);
        }
    }
    
    const handleAccept = useCallback(() => {
        if (signaler) {
          let id = callerData.apptId;
          signaler.acceptCallRequest(callerData.senderId, callerData.apptId);
          // setRoomId(callerData.roomId);
          setCallerData(null);
          // history.push(`/conference/${id}`);
    
        }
    }, [signaler, callerData, history]);
    

    return <Fragment>
        <Header handleSlide={handleSideNav} role={props.role}/>
        <Sidenav handleSlide={handleSideNav} slide={sideNav} handleLogout={handleLogout} role={props.role}/>
        <WebSideNav handleLogout={handleLogout} role={props.role}/>
        <div className="innerMainContainer">
            <Suspense fallback={<Loading />}>
                <Route exact path={props.path} component={props.component} {...props} />
            </Suspense>
            {
            callerData !== null &&
                <IncommingCall inCall={callerData !== null} handleInCall={() => declineRequest()} userData={callerData} handleAccept={handleAccept} />
            }
        </div>
    </Fragment>
}

export default AuthLayout;
